import * as React from "react";
const MenuIcon = (props) => (
  <svg
    width={21}
    height={14}
    viewBox="0 0 21 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M1 1H20" stroke="#BD9F3F" strokeWidth={2} strokeLinecap="round" />
    <path d="M1 7H20" stroke="#BD9F3F" strokeWidth={2} strokeLinecap="round" />
    <path d="M1 13H20" stroke="#BD9F3F" strokeWidth={2} strokeLinecap="round" />
  </svg>
);
export default MenuIcon;
